import { CardWithContent } from '@/components/molecules/card-with-content';
import { getLabel } from '@/utils/get-label';
import { Avatar, Box, Checkbox, Typography } from '@mui/material';

interface ListCardProps {
  name: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
  secondaryName?: string;
  rightText?: string;
  showCheckbox?: boolean;
}

export const ListCard = ({
  name,
  description,
  isSelected,
  onClick,
  secondaryName,
  rightText,
  showCheckbox,
}: ListCardProps) => {
  const displayName = getLabel({ values: [name, secondaryName], fallback: '-' });

  const initials = [name?.[0]?.toUpperCase(), secondaryName?.[0]?.toUpperCase()]
    .filter(Boolean)
    .join('');

  return (
    <CardWithContent isSelected={isSelected} onClick={onClick}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
        {showCheckbox && <Checkbox checked={isSelected} />}

        <Avatar
          variant="rounded"
          sx={{
            backgroundColor: 'background.default',
            borderColor: 'divider',
            borderStyle: 'solid',
            borderWidth: 1,
            mr: 2,
            minWidth: 40,
            minHeight: 40,
          }}
        >
          {initials}
        </Avatar>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            columnGap: 2,
          }}
        >
          <Box>
            <Typography
              color="textPrimary"
              sx={{
                mb: 1,
              }}
              variant="h6"
            >
              {displayName}
            </Typography>
            <Typography color="textSecondary" variant="body2">
              {description}
            </Typography>
          </Box>
          {rightText && (
            <Typography color="primary.main" variant="body1">
              {rightText}
            </Typography>
          )}
        </Box>
      </Box>
    </CardWithContent>
  );
};
